export default __webpack_public_path__ + "static/media/Chandrashekhar Wagh.5e66e7d2.jpg";